export const authHeaders = {
  account: 'vault-account-id',
  service: 'vault-service-id',
};
